<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="radio_group">
        <label>Discount type: </label>
        <mat-radio-group [(ngModel)]="discountObj.discountType">
          <mat-radio-button [value]="2">Whole Amount</mat-radio-button>
          <mat-radio-button [value]="1">Percentage</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="form-group" style="display: flex; gap: 20px;">
        <label for="Description">Discount available on:</label>
        <div class="add_crt" style="display: flex; gap: 20px;">
         
                <div class=" try" *ngIf="shop_status != '2'">
                  <mat-checkbox [value]="discountObj.shop_service_status" (change)="selectCheck($event,1)" [checked]="discountObj.shop_service_status == 1"></mat-checkbox>

   
                    <label for="testing1" class="check-label">Shop service</label>
                </div>
                <div class=" try" *ngIf="home_status != '2'">
                  <mat-checkbox [value]="discountObj.home_service_status" (change)="selectCheck($event,0)" [checked]="discountObj.home_service_status == 1"></mat-checkbox>

   
                    <label for="testing1" class="check-label">Home service</label>
                </div>
                <div class=" try" *ngIf="virtual_status != '2'">
                  <mat-checkbox [value]="discountObj.virtual_service_status" (change)="selectCheck($event,2)" [checked]="discountObj.virtual_service_status == 1"></mat-checkbox>

   
                    <label for="testing1" class="check-label">Virtual service</label>
                </div>
               
         
        </div>
    </div>
      <div >
        <mat-form-field appearance="outline">
            <mat-label *ngIf="discountObj.discountType == 2">Enter discount value</mat-label>
          <mat-label *ngIf="discountObj.discountType == 1">Enter discount in percentage %</mat-label>
          <input  smDecimalOnly  type="number" matInput [(ngModel)]="discountObj.discountAmount "/>
          <!--  -->
        </mat-form-field>
      </div>
      <div >
        <mat-form-field appearance="outline">
          <mat-label>Enter minimum bill amount</mat-label>
          <input  smDecimalOnly  type="number" matInput [(ngModel)]="discountObj.minBillAmount "/>
          <!--  -->
        </mat-form-field>
      </div>
      <div *ngIf="discountObj.discountType == 1">
        <mat-form-field appearance="outline">
          <mat-label>Enter maximum discount amount</mat-label>
          <input  smDecimalOnly  type="number" matInput [(ngModel)]="discountObj.maxDiscount "/>
          <!--  -->
        </mat-form-field>
      </div>
      <div >
        <mat-form-field class="date" appearance="outline">
          <mat-label>Start date</mat-label>
          <input matInput [matDatepicker]="picker1" [(ngModel)]="discountObj.start_date ">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        
        <mat-form-field class="date" appearance="outline">
          <mat-label>End date</mat-label>
          <input matInput [matDatepicker]="picker2" [(ngModel)]="discountObj.end_date ">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
    
       
      </div>
      <div class="item_list add_padding" >
        <div class="item_list_data add_margin_bottom">
          <span>Enable Other Discount</span>
          <mat-slide-toggle [checked]="discountObj.otherDiscounts == 1" (change)="onToggleChangeOtherDiscount($event)"></mat-slide-toggle>
        </div>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      (click)="onSubmitDiscountDetails()"
      [disabled]="
      !discountObj.discountAmount ||
      !discountObj.minBillAmount ||
      !discountObj.start_date ||
      !discountObj.end_date 
      
      "
    >
      Confirm
    </button>
  </mat-dialog-actions>